import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({ standalone: false, name: 'sanitise' })
export class SanitisePipe implements PipeTransform {
  transform(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
